{
  "dog": {
    "hitboxPx": [48, 24], "heightPx": 40, "crashAtSpeed": { "medium": 0, "large": 99 }, "speedLoss": 0.5,
    "triggerM": 18, "alertS": 0.6, "speed": 11, "chaseS": 3, "leadS": 0.4, "fleeSpeed": 9, "tumbleS": 0.6
  },
  "hiker": {
    "hitboxPx": [32, 20], "heightPx": 110, "crashAtSpeed": { "medium": 99, "large": 99 }, "speedLoss": 0.6,
    "walkSpeed": 1.2, "startleM": 10, "leapM": 2.5, "leapS": 0.4, "bellRangeM": 50, "asideSpeed": 4, "clearMarginM": 1
  },
  "npc_rider": {
    "hitboxPx": [40, 32], "heightPx": 120, "crashAtSpeed": { "medium": 0, "large": 25 }, "speedLoss": 0.6,
    "speed": 15, "lookAheadM": 18, "laneM": 1.2, "clearanceM": 0.8, "turnRate": 180, "fallenS": 2
  },
  "wildlife": {
    "cow":    { "hitboxPx": [140, 40], "heightPx": 120, "crashAtSpeed": { "medium": 4, "large": 12 }, "speedLoss": 0.8, "speed": 0.4, "boltSpeed": 0, "boltM": 0 },
    "sheep":  { "hitboxPx": [90, 30],  "heightPx": 70,  "crashAtSpeed": { "medium": 8, "large": 20 }, "speedLoss": 0.5, "speed": 0.6, "boltSpeed": 0, "boltM": 0 },
    "deer":   { "hitboxPx": [100, 30], "heightPx": 110, "crashAtSpeed": { "medium": 6, "large": 16 }, "speedLoss": 0.7, "speed": 0.5, "boltSpeed": 9, "boltM": 25 },
    "marmot": { "hitboxPx": [40, 20],  "heightPx": 30,  "crashAtSpeed": { "medium": 15, "large": 30 }, "speedLoss": 0.2, "speed": 0, "boltSpeed": 0, "boltM": 0 }
  }
}
